import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { FiLock, FiMail, FiUser } from "react-icons/fi";
import { Alert, Button, Checkbox, Form, Input, Typography } from "antd";
import { setHtmlStorage } from "../../config/helper";
import { authSignup } from "../../store/auth/action";
import styles from "./signup.module.css";

class SignUp extends Component {
	constructor(props) {
		super(props);
		this.state = {
			username: "",
			email: "",
			password: "",
			conPassword: "",
			disclaimer: false,
			errorUsername: {
				show: false,
				status: "",
				message: null,
			},
			errorEmail: {
				show: false,
				status: "",
				message: null,
			},
			errorPassword: {
				show: false,
				status: "",
				message: null,
			},
			errorConPassword: {
				show: false,
				status: "",
				message: null,
			},
			errorDisclaimer: {
				show: false,
				status: "",
				message: null,
			},
			alertState: {
				show: false,
				variant: "error",
				message: "",
			},
		};
		this.handleSignUpForm = this.handleSignUpForm.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
	}

	handleSignUpForm = async () => {
		if (this.state.username === "") {
			this.setState({
				errorUsername: {
					show: true,
					status: "error",
					message: "This field cannot be empty.",
				},
			});
			return;
		}
		if (this.state.username.includes(" ")) {
			this.setState({
				errorUsername: {
					show: true,
					status: "error",
					message: "This field cannot contain spaces.",
				},
			});
			return;
		}
		if (this.state.email === "") {
			this.setState({
				errorEmail: {
					show: true,
					status: "error",
					meesage: "This field cannot be empty.",
				},
			});
			return;
		}
		if (this.state.password === "") {
			this.setState({
				errorPassword: {
					show: true,
					status: "error",
					message: "This field cannot be empty.",
				},
			});
			return;
		}
		if (
			!/(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}/.test(
				this.state.password
			)
		) {
			this.setState({
				errorPassword: {
					show: true,
					status: "error",
					message:
						"This field must contain at least eight characters, one number, one uppercase, one lowercase, and one non-alphanumeric (e.g @$!%*#).",
				},
			});
			return;
		}
		if (this.state.conPassword === "") {
			this.setState({
				errorConPassword: {
					show: true,
					status: "error",
					message: "This field cannot be empty.",
				},
			});
			return;
		}
		if (this.state.password !== this.state.conPassword) {
			this.setState({
				errorPassword: {
					show: true,
					status: "error",
					message:
						"The password and confirmation password do not match.",
				},
				errorConPassword: {
					show: true,
					status: "error",
					message:
						"The password and confirmation password do not match.",
				},
			});
			return;
		}
		if (!this.state.disclaimer) {
			this.setState({
				errorDisclaimer: {
					show: true,
					status: "error",
					message: "This field cannot be empty.",
				},
			});
			return;
		}

		const payload = {
			data: JSON.stringify({
				username: this.state.username,
				email: this.state.email,
				password: this.state.password,
				confirmPassword: this.state.conPassword,
			}),
		};

		await this.props.authSignup(payload);

		if (
			this.props.signupResponse.httpStatus === 401 &&
			this.props.signupResponse.data.message ===
				"This Email Exists in Our System but has not been confirmed yet Please Confirm your Email"
		) {
			setHtmlStorage("resendEmail", this.props.signupResponse.data.email);
			this.setState({
				alertState: {
					show: true,
					variant: "error",
					message:
						"This e-mail is exist in our system but not confirmed yet, please confirm your e-mail.",
				},
			});
			setTimeout(() => {
				window.location.href = "/resend-email-confirmation";
			}, 3000);
		}

		if (this.props.signupResponse.httpStatus === 200) {
			setHtmlStorage("signup-email", this.state.email);
			setHtmlStorage(
				"signup-message",
				this.props.signupResponse.data.message
			);
			window.location.href = "/signup/success";
		}

		if (this.props.signupResponse.httpStatus === 400) {
			this.setState({
				alertState: {
					show: true,
					variant: "error",
					message: this.props.signupResponse.data,
				},
			});
		}

		if (this.props.signupResponse.httpStatus === 500) {
			let message = "";
			if (typeof this.props.signupResponse.data === "object") {
				for (
					let i = 0;
					i < this.props.signupResponse.data.length;
					i++
				) {
					const element = this.props.signupResponse.data[i];
					message.push(element.description);
				}
				if (message.length > 0) {
					message = message.join("<br />");
				}
			}
			if (typeof this.props.signupResponse.data === "string") {
				message = this.props.signupResponse.data;
			}
			this.setState({
				alertState: {
					show: true,
					variant: "error",
					message: message,
				},
			});
		}
	};

	handleInputChange = (evt) => {
		const { name, value } = evt.target;
		this.setState({ [name]: value });
		this.resetErrorField();
	};

	handleCheckboxChange = () => {
		this.setState({ disclaimer: !this.state.disclaimer });
		this.resetErrorField();
	};

	resetErrorField = () => {
		this.setState({
			alertState: {
				show: false,
				variant: "error",
				message: "",
			},
			errorUsername: {
				show: false,
				status: "",
				message: null,
			},
			errorEmail: {
				show: false,
				status: "",
				message: null,
			},
			errorPassword: {
				show: false,
				status: "",
				message: null,
			},
			errorConPassword: {
				show: false,
				status: "",
				message: null,
			},
			errorDisclaimer: {
				show: false,
				status: "",
				message: null,
			},
		});
	};

	render() {
		return (
			<div className={styles.auth_signup_page}>
				<div className={styles.auth_wrapper}>
					<Typography.Title
						level={3}
						className={styles.auth_signup_title}
					>
						Sign Up
					</Typography.Title>
					{this.state.alertState.show && (
						<Alert
							type={this.state.alertState.variant}
							message={this.state.alertState.message}
							closable
							onClose={() =>
								this.setState({
									alertState: {
										show: false,
										variant: "error",
										message: "",
									},
								})
							}
						/>
					)}
					<Form
						colon={false}
						autoComplete="off"
						layout="vertical"
						onFinish={this.handleSignUpForm}
					>
						<Form.Item
							hasFeedback={this.state.errorUsername.show}
							validateStatus={this.state.errorUsername.status}
							help={this.state.errorUsername.message}
						>
							<Input
								placeholder="Username"
								name="username"
								prefix={<FiUser />}
								value={this.state.username}
								onChange={this.handleInputChange}
							/>
						</Form.Item>
						<Form.Item
							hasFeedback={this.state.errorEmail.show}
							validateStatus={this.state.errorEmail.status}
							help={this.state.errorEmail.message}
						>
							<Input
								type="email"
								placeholder="Email"
								name="email"
								prefix={<FiMail />}
								value={this.state.email}
								onChange={this.handleInputChange}
							/>
						</Form.Item>
						<Form.Item
							hasFeedback={this.state.errorPassword.show}
							validateStatus={this.state.errorPassword.status}
							help={this.state.errorPassword.message}
						>
							<Input.Password
								placeholder="Password"
								name="password"
								prefix={<FiLock />}
								value={this.state.password}
								onChange={this.handleInputChange}
							/>
						</Form.Item>
						<Form.Item
							hasFeedback={this.state.errorConPassword.show}
							validateStatus={this.state.errorConPassword.status}
							help={this.state.errorConPassword.message}
						>
							<Input.Password
								placeholder="Confirm Password"
								name="conPassword"
								prefix={<FiLock />}
								value={this.state.conPassword}
								onChange={this.handleInputChange}
							/>
						</Form.Item>
						<Form.Item
							hasFeedback={this.state.errorDisclaimer.show}
							validateStatus={this.state.errorDisclaimer.status}
							help={this.state.errorDisclaimer.message}
						>
							<Checkbox
								name="disclaimer"
								checked={this.state.disclaimer}
								onChange={this.handleCheckboxChange}
							>
								By participating in this beta test, I
								acknowledge that I have read and agree to the{" "}
								<Link
									to="/faqs"
									style={{ textDecoration: "underline" }}
								>
									Data Privacy FAQs
								</Link>{" "}
								and will not engage in any violent, offensive,
								explicit, or profane behaviour with the AI
								Companionship.
							</Checkbox>
						</Form.Item>
						<Button
							type="primary"
							htmlType="submit"
							className={styles.btn_signup}
							loading={this.props.loading}
						>
							Sign Up
						</Button>
						<Typography.Text className={styles.auth_signup_account}>
							Already have an account?&nbsp;
							<Link to="/signin">Sign In</Link>
						</Typography.Text>
					</Form>
				</div>
			</div>
		);
	}
}

const stateToProps = (state) => {
	const { auth } = state;
	return {
		loading: auth.loading,
		signupResponse: auth.signupResponse,
	};
};

const dispatchToProps = (dispatch) => ({
	authSignup: (payload) => dispatch(authSignup(payload)),
});

export default connect(stateToProps, dispatchToProps)(SignUp);
